import { useCallback, useEffect, useState } from 'react';
import { reelService } from 'api/services/ReelService';
import type { ReelMineViewModel } from 'api/types/reel';

export function useMyReels(enabled = true) {
  const [reels, setReels] = useState<ReelMineViewModel[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refetch = useCallback(async () => {
    if (!enabled) {
      setReels([]);
      setLoading(false);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const result = await reelService.getMine();
      if (result.isSuccess && result.data) {
        setReels(result.data);
      } else {
        setReels([]);
        setError(result.message ?? 'Gönderiler yüklenemedi.');
      }
    } catch (err) {
      setReels([]);
      setError(err instanceof Error ? err.message : 'Bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  const removeReel = useCallback((reelId: string) => {
    setReels((prev) => prev.filter((item) => item.id !== reelId));
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { reels, loading, error, refetch, removeReel };
}
